const guidesContent = {
  '竞技扑克新手入门规则': [
    `<h2>德州扑克基础规则与新手入门指南</h2>
     <p>竞技扑克（Texas Hold'em），又称德州扑克，是目前世界上最受欢迎的扑克衍生游戏，也是HHpoker（德扑圈）平台上的核心竞技项目。它结合了概率学、心理学和风险管理，是智力竞技的典范。每位玩家会分得两张手牌（底牌），并与公用的五张公共牌结合，组成最大的五张牌型进行比牌。</p>
     <h3>德扑游戏流程详解</h3>
     <ol>
       <li><strong>盲注（Blinds）</strong>：庄家（Button）左侧分别为小盲注（SB）和大盲注（BB），这是强制下注，确保底池有筹码可争夺。</li>
       <li><strong>翻牌前（Pre-flop）</strong>：拿到两张底牌后，玩家根据底牌质量决定是否入局。德扑圈中，位置越靠后越有利。</li>
       <li><strong>翻牌圈（Flop）</strong>：发出三张公共牌。这是连接底牌与公牌的关键轮次，也是大多数牌局胜负的分水岭。</li>
       <li><strong>转牌圈（Turn）</strong>：发出第四张公共牌。底池通常在此刻变大，需要谨慎计算赔率。</li>
       <li><strong>河牌圈（River）</strong>：发出第五张公共牌。这是最后的决策机会，比牌或通过诈唬（Bluff）赢取底池。</li>
     </ol>
     <h3>德州扑克牌型大小排行</h3>
     <p>熟悉牌型是入门第一步。从大到小依次为：皇家同花顺 > 同花顺 > 四条（金刚） > 葫芦 > 同花 > 顺子 > 三条 > 两对 > 一对 > 高牌。</p>
     <h3>新手起手牌策略</h3>
     <p>在HHpoker这样的竞技环境中，并非所有牌都值得玩。新手应遵循“紧凶”策略：</p>
     <ul>
       <li><strong>只玩强牌</strong>：如AA、KK、QQ、AKs等高对或大同花连张。</li>
       <li><strong>利用位置</strong>：在按钮位（BTN）可以适当放宽手牌范围，而在枪口位（UTG）则必须非常谨慎。</li>
     </ul>
     <h3>资金管理（Bankroll Management）</h3>
     <p>不要在单次买入中投入过多资金。合理的资金管理能助你在德扑圈长期生存，抵御波动。</p>`,
  ],
  '奥马哈Omaha竞技详解': [
    `<h2>奥马哈（Omaha）玩法规则与进阶策略</h2>
     <p>奥马哈是仅次于德州扑克的第二大流行扑克游戏。在HHpoker平台上，奥马哈因其成牌率高、波动大、刺激性强而深受玩家喜爱。与德州扑克最大的区别在于：每位玩家有四张底牌，且<strong>必须</strong>使用两张底牌和三张公共牌组成牌型。</p>
     <h3>奥马哈起手牌选择</h3>
     <p>好的奥马哈起手牌应当四张牌都互相关联（Double Suited连接性好）。例如：A♠K♠J♥10♥ 是极佳的起手牌，因为它有双同花和连顺的潜力。</p>
     <h3>核心差异与技巧</h3>
     <ol>
       <li><strong>坚果牌（The Nuts）思维</strong>：在奥马哈中，非坚果牌（如二顺、非同花最大牌）很容易输掉大底池。时刻评估自己是否持有当前牌面下的最强牌。</li>
       <li><strong>听牌价值巨大</strong>：由于底牌多，裹手顺子听牌（Wrap）可能有高达13-20张补牌，这让听牌在翻牌圈往往比成牌（如暗三条）还有优势。</li>
       <li><strong>位置更重要</strong>：由于手牌组合多，底池往往造得很大，有位置优势能让你更好地控制底池大小。</li>
     </ol>
     <h3>总结</h3>
     <p>奥马哈是“勇敢者的游戏”，需要更严谨的数学计算和对波动（Variance）的承受能力。</p>`],
  '进阶攻略：位置的重要性': [
    `<h2>德州扑克中的位置学问：为什么位置就是金钱？</h2>
     <p>在德扑圈流传一句话：“位置就是一切”。位置（Position）决定了你的行动顺序。后行动的玩家拥有巨大的信息优势，因为他们可以观察前面玩家的行动（过牌、下注、加注）后再做决策。</p>
     <h3>位置分类与策略</h3>
     <ul>
       <li><strong>前位（EP - Early Position）</strong>：如枪口位（UTG）。最先行动，风险最大，只能玩最强的牌（如AA, KK, AK）。</li>
       <li><strong>中位（MP - Middle Position）</strong>：处于中间，策略较为中庸，可适当增加同花连张等投机牌。</li>
       <li><strong>后位（LP - Late Position）</strong>：如关煞位（CO）和按钮位（BTN）。这是德州扑克中最赚钱的位置，可以利用位置优势进行偷盲（Steal Blinds）或对前面玩家进行隔离（Isolate）。</li>
     </ul>
     <h3>如何利用位置优势？</h3>
     <p>1. <strong>控池</strong>：有位置时，你可以选择过牌看免费牌，或者下注做大底池。</p>
     <p>2. <strong>诈唬更有效</strong>：当对手过牌表示示弱时，你在后位下注通过率更高。</p>
     <p>3. <strong>价值最大化</strong>：当你持有强牌，对手在前位下注，你可以选择加注或者平跟埋伏。</p>
     <p><strong>HHpoker进阶提示</strong>：在实战中，即使手牌一般，利用好按钮位（BTN）也能通过技巧赢下底池。</p>`],
  '积分管理：如何长期提升战绩': [
    `<h2>德州扑克资金管理（BRM）：职业选手的必修课</h2>
     <p>在竞技扑克中，技术决定你能赢多少，而资金管理（Bankroll Management）决定你能活多久。无论在德扑圈还是线下局，忽视资金管理是破产的主要原因。</p>
     <h3>黄金法则</h3>
     <ul>
       <li><strong>买入量原则</strong>：建议至少准备20-30个常规桌买入（Buy-in）。例如打1/2级别，买入200，账户应至少有4000-6000积分。</li>
       <li><strong>止损线</strong>：设定每日或单次Session的止损点（如3-5个买入）。上头（Tilt）时最容易输光，止损是保护自己的最后防线。</li>
       <li><strong>级别升降</strong>：当资金增长到下一级别要求的20个买入时尝试升级；反之，若遭遇下风期（Downswing），应果断降级打牌，重建信心。</li>
     </ul>
     <h3>心态建设</h3>
     <p>接受波动是德州扑克的一部分。即使是世界冠军也会经历下风期。保持平稳心态，坚持做+EV（正期望值）的决策，长期来看盈利是必然的。</p>`],
  '竞技牛仔玩法介绍': [
    `<h2>德扑圈牛仔玩法（Cowboy）规则介绍</h2>
     <p>牛仔玩法是近年来在各大德扑APP（如HHpoker）中流行的一种娱乐性变体。它在传统德州扑克规则基础上增加了特殊机制，让游戏更加刺激有趣。</p>
     <h3>常见特色规则</h3>
     <ul>
       <li><strong>换牌卡</strong>：允许玩家在特定环节更换一张底牌或公共牌，极大增加了变数。</li>
       <li><strong>保险机制</strong>：针对全押（All-in）情况提供保险购买，降低被“发死”（Bad Beat）的损失。</li>
       <li><strong>多板（Multi-Board）</strong>：一次发两次或三次公共牌，底池按比例分配，降低波动。</li>
       <li><strong>72赏金</strong>：如果玩家用72杂色（公认最差起手牌）赢下底池，全桌其他玩家需支付额外奖励。</li>
     </ul>
     <h3>牛仔玩法策略调整</h3>
     <p>由于存在换牌等变数，传统的手牌胜率计算会有所偏差。建议玩家更注重娱乐心态，同时在有强力道具辅助时通过激进打法索取价值。</p>`,
  ],
  '如何识别和利用对手的马脚': [
    `<h2>德州扑克读牌技巧：识别马脚（Tells）</h2>
     <p>在线下扑克或真人德扑中，物理马脚（如手抖、眼神闪躲）很重要。但在HHpoker这类线上德扑圈APP中，我们需要关注“线上马脚”和“数据马脚”。</p>
     <h3>常见的线上马脚</h3>
     <ul>
       <li><strong>行动时间（Timing Tell）</strong>：
         <br/>- <strong>秒跟（Instant Call）</strong>：通常代表听牌或者是中等强度的成牌，极少是坚果牌（因为强牌通常会思考如何以此做大底池）。
         <br/>- <strong>长考后Check</strong>：往往代表想以此示弱，或者确实很难做决定。
         <br/>- <strong>长考后All-in</strong>：在低级别局中，这通常代表超强牌，切勿轻举妄动。</li>
       <li><strong>下注尺度（Bet Sizing）</strong>：
         <br/>- <strong>超小注</strong>：通常是阻拦下注（Blocker Bet），想便宜看下一张牌。
         <br/>- <strong>底池满注</strong>：极化范围，要么是坚果，要么是纯诈唬。</li>
     </ul>
     <h3>利用HUD数据</h3>
     <p>利用VPIP（入池率）、PFR（翻前加注率）、3-Bet%等数据来给对手归类（如“紧凶”、“松弱”、“鱼”），从而制定针对性的剥削策略（Exploitative Strategy）。</p>`
  ]
};

module.exports = guidesContent;
